import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { api } from "@/lib/api";
import { CalendarDays, Tag } from "lucide-react";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/blog").then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="blog-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-5xl mx-auto px-6 py-16 w-full">
          <div className="chip mb-6">Yonsii Geek Blog</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
            Tech tips for <span className="text-brand">real humans.</span>
          </h1>
          <p className="text-slate-400 mt-3 max-w-2xl">
            Short, practical fixes and stories from the geeks behind Yonsii Geek Support.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            {loading && (
              <div className="text-slate-500 col-span-2 text-center py-10">Loading…</div>
            )}
            {!loading && articles.length === 0 && (
              <div className="text-slate-500 col-span-2 text-center py-10">No articles yet.</div>
            )}
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/blog/${a.slug}`}
                data-testid={`blog-card-${a.slug}`}
                className="soft-card p-6 hover:shadow-lg transition-shadow"
              >
                <div className="chip-light mb-3">
                  <Tag className="w-3.5 h-3.5" /> {a.category}
                </div>
                <h2 className="font-display font-bold text-xl text-slate-900">{a.title}</h2>
                <p className="text-slate-500 mt-2 text-sm line-clamp-3">{a.excerpt}</p>
                <div className="text-xs text-slate-400 mt-4 flex items-center gap-1">
                  <CalendarDays className="w-3.5 h-3.5" />{" "}
                  {a.published_at ? new Date(a.published_at).toLocaleDateString() : ""}
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
